import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { memberKeys } from './memberKeys';

interface ChangeMemberRoleInput {
  membershipId: string;
  roleId: string;
}

export function useChangeMemberRole() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: ({ membershipId, roleId }: ChangeMemberRoleInput) =>
      apiClient
        .put(`api/v1/t/${tenantId}/members/${membershipId}/role`, { json: { roleId } })
        .json(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: memberKeys.lists() });
    },
  });
}
